import { render, staticRenderFns } from "./LogoutIndex.vue?vue&type=template&id=c07b6af0&scoped=true"
import script from "./LogoutIndex.vue?vue&type=script&lang=js"
export * from "./LogoutIndex.vue?vue&type=script&lang=js"
import style0 from "./LogoutIndex.vue?vue&type=style&index=0&id=c07b6af0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07b6af0",
  null
  
)

export default component.exports